module.exports = __webpack_public_path__ + "img/1sb_five_stars_unselected_trustpilot_d.131aa2c.svg";